import { RenderElementProps } from 'slate-react';

export const ELEMENT_IELTS_CALENDAR_COMPUTER_BASED = 'ielts-calendar-computer-based';

export interface IeltsCalendarComputerBasedOptions {
  isReadOnly?: boolean;
}
export interface IeltsCalendarComputerBasedElementProps
  extends RenderElementProps,
    IeltsCalendarComputerBasedOptions {}
